import React from 'react'
import styled from 'styled-components'
import Button from '../../../../components/Button'

import cloneDeep from 'lodash.clonedeep'

import SectionEditor from './SectionEditor'
const Section = styled.div`
  display: flex;
  flex-direction: column;
`

const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid black;
  border-top: none;
`
const ActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.5em;
  background-color: ${({ theme }) => theme.muted};
`

export default function SectionPanel({
  onDeleteSection,
  onSaveSection,
  displayQuestions,
  content,
  questions,
  sectionIndex,
  canDelete,
  sectionName,
}) {
  return (
    <Section>
      <SectionContent>
        <SectionEditor
          initalContent={cloneDeep(content)}
          displayQuestions={displayQuestions}
          questions={questions}
          onSave={onSaveSection}
          sectionIndex={sectionIndex}
          sectionName={sectionName}
        />
        <ActionContainer>
          {sectionIndex.length === 2
            ? <div />
            : <Button
                disabled={!canDelete}
                onClick={onDeleteSection}
                raised
                accent>
                Delete this Section
              </Button>}
        </ActionContainer>
      </SectionContent>
    </Section>
  )
}



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/LearnerGuide/SectionContent/SectionPanel.js